import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { DxSharedModule } from 'src/shared/dx-shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { LayoutsModule } from 'src/core/layouts/layouts.module';
import { AgmCoreModule } from '@agm/core';
import { DashboardStore } from './state/dashboard.store';
import { ParcsStore } from '../parcs/state/parcs.store';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    DashboardComponent,
  ],
  imports: [
    SharedModule,
    DxSharedModule,
    TranslateModule,
    RouterModule,
    LayoutsModule,
    AgmCoreModule,
    NgxsModule.forFeature([
      DashboardStore,
      ParcsStore
    ])
  ],
  exports: [
    DashboardComponent
  ],
})
export class DashboardModule { }
